var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.lang + "-lang"),attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-baf3c1f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!(webpack)-in-loader?{"localeFile":"/Users/fiend/Downloads/workspace/workspace-shupao/global/saudi/base/uaa-fe/locale/zh.js"}!./src/App.vue
// module id = Njf3
// module chunks = 8